import { SxProps } from "@mui/material/styles";

export const iconPointer: SxProps = {
  cursor: "pointer",
  pointerEvents: "auto",
};
